import { environment } from "../../../environments/environment";

export const SECURITY = {
  AUTHORIZATION_BASIC: {
    BEFORE_LOGIN: environment.authorizationApiToken_BEFORE,
    AFTER_LOGIN: environment.authorizationApiToken_AFTER
  }
};

export const API_CALL_URL = {
  DEMO: {
    path: '/demo',
    params: {}
  },
  DEMO2: {
    path: '/demo/{id}',
    params: {
      id: {
        key: 'id',
        value: ''
      }
    }
  },
  ROOM_ACCESS: {
    path: '/rooms/accesses/{attendantId}',
    params: {
      attendantId: {
        key: 'attendantId',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.BEFORE_LOGIN
    }
  },
  ROOM_ACCESS_PIN: {
    path: '/rooms/accesses/{attendantId}?{key}{password}',
    params: {
      attendantId: {
        key: 'attendantId',
        value: ''
      },
      password: {
        key: 'password',
        value: ''
      },
      key: {
        key: 'key',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.BEFORE_LOGIN
    }
  },
  ROOM_VALIDATE: {
    path: '/rooms/accesses/validate/{attendantId}?pin={password}',
    params: {
      attendantId: {
        key: 'attendantId',
        value: ''
      },
      password: {
        key: 'password',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.BEFORE_LOGIN
    }
  },
  CONNECTION_TEST_TOKEN: {
    path: '/connection-test-token',
    params: {},
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.BEFORE_LOGIN
    }
  },
  CONNECTION_TEST_TOKEN_PATIENT: {
    path:'/connection-test-token?attendantId={attendantId}',
    params: {
      attendantId: {
        key: 'attendantId',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.BEFORE_LOGIN
    }
  },
  SET_USER_STATE: {
    path: '/activated?access={attendantId}&active={active}',
    params: {
      attendantId: {
        key: 'attendantId',
        value: ''
      },
      active: {
        key: 'active',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN
    }
  },
  GET_USER_STATE: {
    path: '/activated-health-professional?access={attendantId}',
    params: {
      attendantId: {
        key: 'attendantId',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN
    }
  },
  SEND_INVITATION: {
    path: '/attendants/add',
    params: {},
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN
    }
  },
  // GET_ATTENDANTS: {
  //   path: '/attendants?roomAttendantId={attendantId}',
  //   params: {
  //     attendantId: {
  //       key: 'attendantId',
  //       value: ''
  //     }
  //   },
  //   security: {
  //     authorizationBasic: SECURITY.AUTHORIZATION_BASIC.BEFORE_LOGIN
  //   }
  // },
  GET_ATTENDANTS: {
    path: '/a?id={attendantId}',
    params: {
      id: {
        key: 'attendantId',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.BEFORE_LOGIN
    }
  },
  GET_ACTIVE_SURVEY: {
    path: '/surveys?active={active}&role={role}',
    params: {
      active: {
        key: 'active',
        value: ''
      },
      role: {
        key: 'role',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN
    }
  },
  SEND_SURVEY: {
    path: '/surveys/{surveyId}/responses',
    params: {
      surveyId: {
        key: 'surveyId',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN
    }
  },
  SEND_SURVEY_PATIENT: {
    path: '/surveys/{surveyId}/responses',
    params: {
      surveyId: {
        key: 'surveyId',
        value: ''
      },
      connectionId: {
        key: 'connectionId',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN
    }
  },
  SEND_CONNECTION: {
    path: '/connections',
    params: {
      attendantId: {
        key: 'attendantId',
        value: ''
      },
      connectionId: {
        key: 'connectionId',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN
    }
  },
  SEND_TUNNING: {
    path: '/tunning',
    params: {
      id: {
        key: 'id',
        value: ''
      },
      createdAt: {
        key: 'createdAt',
        value: ''
      },
      ua: {
        key: 'createdAt',
        value: ''
      },
      browser: {
        name: {
          key: 'name',
          value: ''
        },
        version: {
          key: 'version',
          value: ''
        },
      },
      engine: {
        name: {
          key: 'name',
          value: ''
        },
        version: {
          key: 'version',
          value: ''
        },
      },
      os: {
        name: {
          key: 'name',
          value: ''
        },
        version: {
          key: 'version',
          value: ''
        },
      },
      device: {
        model: {
          key: 'model',
          value: ''
        },
        type: {
          key: 'type',
          value: ''
        },
        vendor: {
          key: 'vendor',
          value: ''
        }
      },
      cpu: {
        architecture: {
          key: 'architecture',
          value: ''
        }
      },
      result: {
        network: {
          key: 'network',
          value: ''
        },
        camera: {
          key: 'camera',
          value: ''
        },
        microphone: {
          key: 'microphone',
          value: ''
        },
        browser: {
          key: 'browser',
          value: ''
        }
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN
    }
  },
  PATTIENT_CONNECTED_NOTIFICATION: {
    path: '/health-professional/patient-connected-notification?attendantId={attendantId}',
    params: {
      attendantId: {
        key: 'attendantId',
        value: ''
      }
    },
    security: {
      authorizationBasic: SECURITY.AUTHORIZATION_BASIC.AFTER_LOGIN
    }
  }
};
